// extracted by mini-css-extract-plugin
export default {"loadMessage":"loader_loadMessage__JCHAB","text":"loader_text__oOz5V","img":"loader_img__CkLAa"};